import './infoboxblue.scss';
import { setOverlay } from '../../../utils/SspProvider/dispatchFunctions';
import { OverlayEnum } from '../../../enums';
import React, { useContext, useRef, useState } from 'react';
import SspProviderContext from '../../../utils/SspProvider/context';
import Slider from 'react-slick';
import VideoPlayer from "../../../components/VideoPlayer";

function InfoBoxBlue(props: { tab: string }) {
    const store = useContext(SspProviderContext);
    const sliderRef = useRef<Slider>(null);
    const contentmodel = store.state.content;
    const brandBanner = contentmodel?.asModel?.reflist('BrandBannerItem');
    const banner =
        brandBanner &&
        brandBanner.filter(item => item.asModel.str('Kategorie') === props.tab) &&
        brandBanner.filter(item => item.asModel.str('Kategorie') === props.tab)[0]?.asModel;
    const assets = banner?.reflist('Assets');
    const [currentAssetIndex, setCurrentAssetIndex] = useState<number>(0);

    if (!banner) return null;

    return (
        <div id='info-dark-blue'>
            <Slider
                className='swipeable-view'
                ref={sliderRef}
                dots={false}
                infinite={false}
                speed={500}
                slidesToShow={1}
                slidesToScroll={1}
                variableWidth={true}
                adaptiveHeight={true}
                initialSlide={currentAssetIndex}
                beforeChange={(_, next) => {
                    setCurrentAssetIndex(next);
                }}
            >
                {assets?.map((asset, index) =>
                    asset.asAsset.fileFamily === 'video' ? (
                        <div className={`video-${index}-${currentAssetIndex}`} key={`banner- ${index}`}>
                            <VideoPlayer
                                key={`video-${index}-${currentAssetIndex}`}
                                videoId={'banner-video'}
                                filetype={asset.asAsset.fileProperties.fileType}
                                link={asset.asAsset.url}
                                autoPlay={currentAssetIndex === index}
                                loopVideo={true}
                                hideControl={true}
                            />
                        </div>
                    ) : (
                        <div key={`banner- ${index}`}>
                            <img className='banner-img' src={asset.asAsset.url} alt={`banner- ${index}`} />
                        </div>
                    )
                )}
            </Slider>
            <div className='info-text'>
                <h2>{banner?.str('Title')}</h2>
                <p>{banner?.str('Description')}</p>
                <button
                    className='transparent-white'
                    onClick={() => {
                        setOverlay(store, {
                            enum: OverlayEnum.ExternalContent,
                            media: banner?.str('Url'),
                        });
                    }}
                >
                    {banner?.str('ButtonTitle')}
                </button>
            </div>
        </div>
    );
}

export default InfoBoxBlue;
